<section class="bg-white fullwidth-section">
  <div class="app-container container-xl container-xl-max-md w-100 pb-lg-4">
    @if (isLoading()) {
    <!-- Same order and same boxes as the loaded page (subject chips, one rail per
         subject in the same grid, the "all courses" list with its filter row),
         so nothing jumps when the data lands. -->
    <ng-container *ngTemplateOutlet="skeletonJump"></ng-container>
    <ng-container *ngTemplateOutlet="skeletonGroup"></ng-container>
    <ng-container *ngTemplateOutlet="skeletonGroup"></ng-container>
    <div class="separator mb-8"></div>
    <ng-container *ngTemplateOutlet="skeletonTable"></ng-container>
    } @else {
    <!-- Jump straight to a subject. The landing page has always had this strip;
         the page people actually land on when they click "คอร์สเรียน" had no
         category navigation at all, so choosing a subject meant scrolling past
         every other subject's rail to find it. -->
    @if (courseCategories.length > 1) {
    <nav class="course-jump overflow-x-auto mb-10 pt-4" data-testid="course-jump">
      @for (category of courseCategories; track category.id) {
      <a class="course-jump__item d-inline-flex align-items-center fw-medium" [routerLink]="`/courses/category/${category.id}`">
        @if (art(category.name); as mark) {
        <span class="course-jump__mark align-items-center justify-content-center"><img [src]="mark" alt="" /></span>
        }
        <span class="course-jump__name text-nowrap fs-7">{{ category.name }}</span>
      </a>
      }
    </nav>
    }

    @for (category of courseCategories; track category; let i = $index) {
    @if (category.recommend_courses.length) {
    <div class="pb-12">
      <div class="d-flex flex-row justify-content-between align-items-center pb-4">
        <p class="fs-1 fs-md-2 fw-bold mb-0 d-flex align-items-center gap-3">
          <!-- The same art the landing page puts on this category, so the
                   two screens name the same thing the same way. -->
          @if (art(category.name); as mark) {
          <span class="course-group__mark align-items-center justify-content-center"><img [src]="mark" alt="" /></span>
          }
          <span>{{ "COURSES.RECOMMEND_COURSE" | translate }} : {{ category.name }}</span>
        </p>
        <!-- Always, not only past four courses. Every rail here holds two
                 or three, so the condition never fired and each rail was a
                 heading with an empty right half and no way out of it. Set as
                 the 2021 build set its "see all": a gold rule under a quiet
                 label, which is the one job that palette's accent had. -->
        <a class="rail-all d-inline-flex align-items-center fw-bolder text-decoration-none flex-shrink-0 fs-6" [routerLink]="`/courses/category/${category.id}`">
          {{ "APP.SHOW_ALL" | translate }}
          <span class="rail-all__arrow" aria-hidden="true">→</span>
        </a>
      </div>

      <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xxl-4 g-6">
        @for (
        recommend_course of category.recommend_courses;
        track recommend_course;
        let j = $index
        ) {
        <app-course-item class="hover-elevate-up" [data]="recommend_course"
          [routerLink]="`/courses/${recommend_course.id}`"></app-course-item>
        }
      </div>
    </div>
    }
    }

    <div class="separator mb-8"></div>

    <div class="pb-12">
      <div class="d-flex flex-row justify-content-between align-items-center mb-4">
        <p class="fs-1 fs-md-2 fw-bold mb-0">
          {{ "COURSES.ALL_COURSE" | translate }}
        </p>
        <!-- <button class="btn btn-primary flex-shrink-0 fw-bold">ดูทั้งหมด</button> -->
      </div>

      <div class="min-h-600px">
        <app-course-table-widget [dataColumns]="columns" [dataSource]="dataSource" [isLoading]="tableLoading()"
          (onRowClick)="onRowClick($event)" (tableChange)="onTableChange($event)" [showCardHeader]="true">
          <section table-header class="col-12 pt-3" [formGroup]="form">
            <div class="col-12">
              <div class="row">
                <!-- The catalogue was the only browse page with no way to
                     search it: three selects and a paginator over a wall of
                     similar titles. /blogs has had one all along. -->
                <div class="col-12 col-lg-3 mb-4 mb-lg-0">
                  <app-input name="keywords" formControlName="keywords" data-testid="course-search"
                    placeholder="APP.SEARCH_COURSE" [labelMode]="LabelMode.NO_LABEL"></app-input>
                </div>
                <div class="col-12 col-sm-4 col-lg-3 mb-4 mb-sm-0">
                  <app-select name="course_category_id" formControlName="course_category_id"
                    placeholder="TABLE.CATEGORY" [labelMode]="LabelMode.NO_LABEL" url="/course_categories"></app-select>
                </div>
                <div class="col-12 col-sm-4 col-lg-3 mb-4 mb-sm-0">
                  <app-select name="sort_order" bindLabel="name" bindValue="value" formControlName="order"
                    placeholder="APP.FIRST_NAME" [labelMode]="LabelMode.NO_LABEL" [options]="sortOptions"></app-select>
                </div>
                <!-- The list could already show a "ทดลองเรียน" button per course
                     but gave no way to see only those, so someone looking for
                     something to try had to page through everything. -->
                <div class="col-12 col-sm-4 col-lg-3">
                  <app-select name="has_trial" bindLabel="name" bindValue="value" formControlName="has_trial"
                    placeholder="APP.TRIAL_ONLY" [labelMode]="LabelMode.NO_LABEL" [options]="trialOptions"></app-select>
                </div>
              </div>
            </div>
          </section>
        </app-course-table-widget>
      </div>
    </div>
    }
  </div>

</section>

<ng-template #skeletonJump>
  <div class="d-flex gap-3 mb-10 pt-4 pb-1 overflow-hidden">
    <div class="skeleton rounded-pill h-50px w-150px flex-shrink-0"></div>
    <div class="skeleton rounded-pill h-50px w-100px flex-shrink-0"></div>
    <div class="skeleton rounded-pill h-50px w-100px flex-shrink-0"></div>
    <div class="skeleton rounded-pill h-50px w-150px flex-shrink-0"></div>
  </div>
</ng-template>

<ng-template #skeletonGroup>
  <div class="pb-12">
    <div class="d-flex flex-row justify-content-between align-items-center pb-4">
      <div class="d-flex align-items-center gap-3 flex-grow-1 me-4">
        <div class="skeleton rounded-3 w-40px h-40px flex-shrink-0"></div>
        <div class="skeleton h-30px w-100 mw-250px"></div>
      </div>
      <div class="skeleton h-30px w-80px flex-shrink-0"></div>
    </div>

    <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xxl-4 g-6">
      @for (i of [1, 2, 3]; track i) {
      <div class="col d-flex">
        <ng-container *ngTemplateOutlet="skeleton"></ng-container>
      </div>
      }
    </div>
  </div>
</ng-template>

<!-- Mirrors `app-course-item`: thumbnail, two-line title, rating row, three lines
     of description, and the lessons / duration footer under a rule. -->
<ng-template #skeleton>
  <div class="course-skeleton-card card w-100">
    <div class="card-body d-flex">
      <div class="d-flex flex-column w-100">
        <div class="skeleton w-100 h-200px"></div>
        <div class="d-flex flex-column justify-content-between flex-grow-1 pt-8">
          <div class="mb-4">
            <div class="skeleton w-100 h-20px mb-2"></div>
            <div class="skeleton w-75 h-20px mb-4"></div>
            <div class="skeleton w-50 h-20px mb-4"></div>
            <div class="skeleton w-100 h-15px mb-3"></div>
            <div class="skeleton w-100 h-15px mb-3"></div>
            <div class="skeleton w-75 h-15px"></div>
          </div>
          <div class="border-top pt-6 d-flex justify-content-between">
            <div class="skeleton h-25px w-80px"></div>
            <div class="skeleton h-25px w-80px"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Mirrors the "all courses" block: heading, then the table card with its
     filter row (search + three selects) and the course rows. -->
<ng-template #skeletonTable>
  <div class="pb-12">
    <div class="skeleton w-200px h-30px mb-4"></div>
    <div class="card w-100">
      <div class="card-header border-0 pt-3 px-6 min-h-auto">
        <div class="row w-100 pt-3">
          <div class="col-12 col-lg-3 mb-4 mb-lg-0"><div class="skeleton h-50px w-100"></div></div>
          <div class="col-12 col-sm-4 col-lg-3 mb-4 mb-sm-0"><div class="skeleton h-50px w-100"></div></div>
          <div class="col-12 col-sm-4 col-lg-3 mb-4 mb-sm-0"><div class="skeleton h-50px w-100"></div></div>
          <div class="col-12 col-sm-4 col-lg-3"><div class="skeleton h-50px w-100"></div></div>
        </div>
      </div>
      <div class="card-body px-6 py-3 pb-5">
        <ng-container *ngTemplateOutlet="skeletonTableItem"></ng-container>
        <div class="separator my-4"></div>
        <ng-container *ngTemplateOutlet="skeletonTableItem"></ng-container>
        <div class="separator my-4"></div>
        <ng-container *ngTemplateOutlet="skeletonTableItem"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<!-- One row of `app-course-table-widget`: 200 x 175 thumbnail, name and
     description, tutor / lessons / duration / level, and stars + price on the
     right from lg up (under the row below lg). -->
<ng-template #skeletonTableItem>
  <div class="d-flex flex-column flex-sm-row gap-sm-5 px-4 py-4">
    <div class="skeleton h-150px h-sm-175px w-100 w-sm-200px flex-shrink-0 mb-4 mb-sm-0"></div>
    <div class="d-flex flex-column flex-md-row flex-grow-1 gap-4">
      <div class="d-flex flex-column justify-content-between flex-grow-1">
        <div>
          <div class="skeleton w-100 mw-300px h-25px"></div>
          <div class="skeleton w-100 h-20px mt-3"></div>
          <div class="skeleton w-100 h-20px mt-2"></div>
          <div class="skeleton w-75 h-20px mt-2"></div>
        </div>
        <div class="d-flex flex-row align-items-center flex-wrap gap-4 mt-4">
          <div class="skeleton rounded-circle w-30px h-30px"></div>
          <div class="skeleton w-100px h-20px"></div>
          <div class="skeleton w-80px h-20px"></div>
          <div class="skeleton w-80px h-20px"></div>
          <div class="skeleton w-80px h-20px"></div>
        </div>
      </div>
      <div class="d-flex flex-row flex-lg-column align-items-lg-end justify-content-between justify-content-lg-start gap-2">
        <ng-container *ngTemplateOutlet="SkeletonStar"></ng-container>
        <div class="skeleton w-80px h-25px"></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #SkeletonStar>
  <div class="d-flex flex-row gap-2">
    <div class="skeleton w-20px h-20px"></div>
    <div class="skeleton w-20px h-20px"></div>
    <div class="skeleton w-20px h-20px"></div>
    <div class="skeleton w-20px h-20px"></div>
    <div class="skeleton w-20px h-20px"></div>
  </div>
</ng-template>
